<template>
  <div class="overlay d-flex flex-column">
    <span class="loader">
      <img
        width="200"
        src="../../../public/playground_assets/Eleven_Tickets_Positivo_Vertical.svg"
      />
    </span>
    <div>
      <h1 class="white--text text-center mt-14 title msg">
        {{ msg }}
      </h1>
    </div>
  </div>
</template>
<script>
export default {
  name: "loaderComponent",
  props: {
    msg: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 9, 27, 0.7);
  display: flex;
  z-index: 999;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(5px);
}
.loader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 19rem;
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.loader:before,
.loader:after {
  content: "";
  position: absolute;
  border-radius: 50%;
  animation: pulsOut 1.8s ease-in-out infinite;
  filter: drop-shadow(0 0 1rem rgba(255, 255, 255, 0.75));
}
.loader:before {
  width: 100%;
  padding-bottom: 100%;
  box-shadow: inset 0 0 0 1rem;
  animation-name: pulsIn;
}
.loader:after {
  width: calc(100% - 2rem);
  padding-bottom: calc(100% - 2rem);
  box-shadow: 0 0 0 0 #fff;
}

@keyframes pulsIn {
  0% {
    box-shadow: inset 0 0 0 1rem #fff;
    opacity: 1;
  }
  50%,
  100% {
    box-shadow: inset 0 0 0 0 #fff;
    opacity: 0;
  }
}

@keyframes pulsOut {
  0%,
  50% {
    box-shadow: 0 0 0 0 #fff;
    opacity: 0;
  }
  100% {
    box-shadow: 0 0 0 1rem #fff;
    opacity: 1;
  }
}
.msg {
  animation: msg 2s ease-in-out;
}

@keyframes msg {
  0% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
</style>
